module.exports = __webpack_public_path__ + "img/pluska-native-background.6bfb7a23.jpg";